import { HttpClient, HttpClientModule } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { ApiClient } from './api-client.service';
import { ApiClientConfig } from './models/api-client.model';

export const loadApiService = (config: ApiClientConfig, httpClient: HttpClient) => new ApiClient(config, httpClient);

export const provideApiClient: (config: Partial<ApiClientConfig>) => EnvironmentProviders = (config) => {
    const providers: Array<EnvironmentProviders | Provider> = [
        { provide: ApiClientConfig, useValue: new ApiClientConfig(config) },
        {
            provide: ApiClient,
            useFactory: loadApiService,
            deps: [ApiClientConfig, HttpClient]
        },
        HttpClientModule
    ];

    return makeEnvironmentProviders(providers);
};
